"use strict";

var _regeneratorRuntime = require("/mnt/d/EJSAK/CarPlatform-v2-frontend/app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/mnt/d/EJSAK/CarPlatform-v2-frontend/app/node_modules/@babel/runtime/helpers/asyncToGenerator");

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  loadYoga: true
};
exports.loadYoga = loadYoga;

var _wrapAssembly = _interopRequireDefault(require("../wrapAssembly"));

var _YGEnums = require("../generated/YGEnums");

Object.keys(_YGEnums).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _YGEnums[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _YGEnums[key];
    }
  });
});

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 */


var loadAssembly = require('../../binaries/wasm-async-web');

function loadYoga() {
  return _loadYoga.apply(this, arguments);
}

function _loadYoga() {
  _loadYoga = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.t0 = (0, _wrapAssembly.default);
            _context.next = 3;
            return loadAssembly();

          case 3:
            _context.t1 = _context.sent;
            return _context.abrupt("return", (0, _context.t0)(_context.t1));

          case 5:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _loadYoga.apply(this, arguments);
}